import {startAssessment, getAssessmentPoints, saveAnswers} from 'utils/assessment'
import {useContext} from 'external/react'
import Assessment from 'context/assessment-context'

export default function useAssessment () {
  const {state, update} = useContext(Assessment.Context)
  const {assessmentLoaded, assessment, questionTypes = []} = state
  const [assessmentsCount = {}, rawAssessments = []] = state.assessments || []
  const getType = id => state.typesMap[id]
  const assessments = rawAssessments.map(a => ({...a, points: getAssessmentPoints(a)}))
  async function start(id) {
    const [startedId] = await startAssessment(id)
    if (!startedId) update({refreshAssessments: {$apply: count => count + 1}})
    return startedId
  }
  async function save(answerUpdates, options = {}) {
    const {sendToServer = true, finalize} = options
    if (!assessmentLoaded) return
    const {assessment: {answers}} = await update({assessment: {$auto: {answers: answerUpdates}}})
    return sendToServer
      ? saveAnswers(assessment.id, answers, finalize)
      : Promise.resolve(true)
  }
  return {assessmentLoaded, assessment, assessments, assessmentsCount, update, getType, start, save, questionTypes}
}
